export default __webpack_public_path__ + "static/media/returnrepair3.3c6ec011.webp";